<template>
  <div ref="enum_display_target">
    <q-select v-if="combobox"
      outlined
      class="thin-input"
      dense
      v-model="group"
      :multiple="allowMultiple"
      :options="options"
    />
    <q-option-group
      v-else
      dense
      v-model="group"
      :options="options"
      size="xs"
      color="primary"
      :type="allowMultiple ? 'checkbox' : 'radio'"
    />
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { reactive, ref } from 'vue';
import { VariableType } from '@/models/etc/types';
import { date } from 'quasar';
import { CommonEntity } from '@/models/interfaces/common';

/**
 * List component displaying v-model with options functionality
 * */
@Component({
  name: 'EnumDisplayList',
  components: {}
})
export default class EnumDisplayList extends Vue {
  // v-model input
  @Prop({ default: [] as any[] })
  elements!: any[]
  // v-model input
  @Prop({ default: [] as any[] })
  modelValue!: any[]
  // update v-model
  @Emit("update:modelValue") emitModelValue(arg: number[]) { return arg; }
  tmpModelData: any[] = reactive([])

  @Prop({ default: undefined })
  enumToString?: (value: number) => string
  @Prop({ default: false })
  allowMultiple?: boolean
  @Prop({ default: false })
  combobox?: boolean
  @Prop({ default: VariableType.String })
  elementType!: VariableType
  
  // dynamic item refs
  group: any = undefined
  divs: any[] = reactive([])
  options: any[] = reactive([])

  @Watch('modelValue', { deep: true })
  created() {
    //
    this.tmpModelData = this.modelValue
    this.options = reactive(this.elements.map(el => {
      return {
        label: this.getElementName(el),
        value: el
      }
    }))
    this.group = !this.combobox ? (!this.allowMultiple ? (this.tmpModelData && this.tmpModelData.length ? this.tmpModelData[0] : 
      (this.options && this.options.length ? this.options[0].value : undefined)) :
      this.tmpModelData) :
      (this.tmpModelData && this.tmpModelData.length ? (this.allowMultiple ? this.tmpModelData.map(el => {
        return {
          label: this.getElementName(el),
          value: el
        }
      }) : {
        label: this.getElementName(this.tmpModelData[0]),
        value: this.tmpModelData[0]
      }) : undefined)
  }

  @Watch('group', { deep: true })
  modelChanged() {
    if (this.group === undefined) { return }
    this.tmpModelData = this.combobox ? (this.allowMultiple ? this.group.map((el: any) => el.value) : this.group.value) : this.group
    
    // @ts-ignore
    this.emitModelValue(this.tmpModelData)
  }

  getElementName(val: any) {
    switch(this.elementType) {
      case VariableType.Entity:
        return (val as CommonEntity).Name
      case VariableType.Date:
        return date.formatDate(new Date(""+val), 'DD.MM.YYYY')
      case VariableType.DateTime:
        return date.formatDate(new Date(""+val), 'DD.MM.YYYY HH:mm:ss')
      case VariableType.Boolean:
        return val ? this.$t('yes_label') : this.$t('no_label')
      case VariableType.Enum:
        return this.enumToString ? this.enumToString(val) : ''+val
      case VariableType.Number:
      case VariableType.String:
      default:
        return ""+val
    }
  }
}
</script>

<style lang="scss">
</style>